var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3",class:{ 'd-none': _vm.item.displayOn && !_vm.display_none_check}},[_c('img',{staticClass:"image-icon ml-3 mr-2",attrs:{"src":_vm.getImgUrl(_vm.item.source)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }